const hash=require('object-hash');
const Fnc=require('usefull-functions');

export default{
	data(){
		return{};
	},
	props:{},
	methods:{
		hash(obj){return hash(obj);},
		...Fnc.default,
		componentByString(str){return {template:str}},
	},
	watch:{},
	created(){},
	computed:{},
}